import { render, staticRenderFns } from "./StartDateEditor.vue?vue&type=template&id=b378a666&"
import script from "./StartDateEditor.vue?vue&type=script&lang=ts&"
export * from "./StartDateEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports